import React from "react";
import PropTypes from "prop-types";
import { Modal, Space } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import NewRoleForm from "../../forms/NewRoleForm";

const RoleModal = ({ initialValues, onSubmit, onClose, open, isEdit }) => {
  const isEditMode = Boolean(initialValues);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <Space>
          {isEditMode ? <EditOutlined /> : <PlusOutlined />}
          {isEditMode ? `Edit Role: ${initialValues.name}` : "Add a Role"}
        </Space>
      }
      width={700}
      centered
      closable
    >
      <NewRoleForm
        isEdit={isEdit}
        initialValues={initialValues}
        submitFunction={onSubmit}
      />
    </Modal>
  );
};

RoleModal.propTypes = {
  initialValues: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default RoleModal;
